export var EUnits;

(function (EUnits) {
  EUnits["area"] = "\u043C\xB2";
})(EUnits || (EUnits = {}));